module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        return _vm.clickHandler(_vm.result)
      }
    }
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.result.title))]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm.result.fromtable) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-563c36c0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchResult.vue
// module id = 633
// module chunks = 2